import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-page-seven',
  templateUrl: './home-page-seven.component.html',
  styleUrls: ['./home-page-seven.component.scss']
})
export class HomePageSevenComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
